import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, Lock } from "lucide-react";
import api, { apiErr, money } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { Panel, AdminHeading, adminInput } from "@/components/admin/ui";

export default function AdminInHouse() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/in-house").then((r) => setData(r.data)).catch(() => setData(false));
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, []);
  const setStatus = async (rid, guest_status) => { try { await api.post(`/admin/reservations/${rid}/guest-status`, { guest_status }); toast.success(guest_status); load(); } catch (e) { toast.error(apiErr(e)); } };
  if (data === null) return <Loading />;
  if (!data) return <p className="text-muted-foreground">Unavailable.</p>;

  return (
    <div>
      <AdminHeading title="Currently at The D" subtitle="Authorized operational board · private, never publicly accessible." />
      <div className="flex items-center gap-2 mb-4 text-xs text-muted-foreground"><Lock size={13} /> Financial details {data.can_view_financial ? "visible" : "hidden"} · private notes {data.can_view_private ? "visible" : "hidden"} for your role.</div>
      <Panel>
        {data.board.length === 0 ? <p className="text-sm text-muted-foreground py-6 text-center flex items-center justify-center gap-2"><Users size={15} /> No active guests today.</p> : (
          <div className="space-y-3">{data.board.map((r) => (
            <div key={r.id} className="p-3 rounded-lg bg-black/20 border border-white/10" data-testid={`inhouse-row-${r.id}`}>
              <div className="flex justify-between items-start gap-3 flex-wrap">
                <div>
                  <p className="font-medium">{r.guest} <span className="text-xs text-muted-foreground">· {r.confirmation_number}</span></p>
                  <p className="text-xs text-muted-foreground">{r.experience} · {r.arrival_date} {r.arrival_time} → {r.departure_date} · {r.party} guests{r.open_concierge ? ` · ${r.open_concierge} open concierge` : ""}</p>
                  {r.special_occasion && <p className="text-xs text-gold mt-0.5">★ {r.special_occasion}</p>}
                  {data.can_view_financial && <p className="text-xs mt-0.5">{r.payment_status} · balance <span className="text-gold">{money(r.balance)}</span></p>}
                </div>
                <select className={adminInput + " text-xs w-auto"} value={r.guest_status} onChange={(e) => setStatus(r.id, e.target.value)} data-testid={`inhouse-status-${r.id}`}>{data.statuses.map((s) => <option key={s}>{s}</option>)}</select>
              </div>
            </div>
          ))}</div>
        )}
      </Panel>
    </div>
  );
}
